import Wrapper from "../../../layout/Wrapper";
import VehicleClaimCenterComponent from "../../../screens/contractControll/vehicleClaimCenter";
import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
  title: "Vehicle Claim Center",
  description: "Vehicle insurance case and claim management",
};

export default function VehicleClaimCenter() {
  return (
    <Wrapper>
      <MetaComponent meta={metadata} />
      <VehicleClaimCenterComponent />
    </Wrapper>
  );
}
